export var getMuiInputAdornmentOverrides = function () { return ({
    positionStart: {
        marginRight: undefined,
    },
    positionEnd: {
        marginLeft: undefined,
    },
}); };
//# sourceMappingURL=MuiInputAdornment.js.map